import { MEDIA_REGISTRY } from "../constants/mediaRegistry.js";
const canonicalMedia = row => {
  const media = String(row._media || row.media || row.source || row._source || "").toUpperCase();
  const alias = ({ NAVER_GFA_CR: "NAVER_GFA", KAKAO_MOMENT: "KAKAO", GOOGLE_SA: "GOOGLE" })[media] || media;
  const registered = MEDIA_REGISTRY.find(entry => [entry.source, entry.label].some(name => String(name).toUpperCase() === alias));
  return String(registered?.source || alias).toUpperCase();
};
const identityPart = (id, name) => id ? ["id", String(id)] : ["name", String(name || "")];
// Media and account identity must survive aggregation even when human-readable names match.
export function reportRowIdentity(row, level = "campaign") {
  const media = canonicalMedia(row);
  const fields = [media, String(row.account_id || row.customer_id || row.advertiser_id || ""),
    identityPart(row.campaign_id, row.campaign_name)];
  if (level !== "campaign") fields.push(identityPart(row.adset_id || row.adgroup_id, row.adset_name));
  if (level === "creative") fields.push(identityPart(row.ad_id || row.creative_no, row.ad_name || row.creative_name));
  return JSON.stringify(fields);
}

// Preserve identity when a summary row becomes the scope of a detail view.
export function reportEntityFields(row) {
  return {
    account_id: row.account_id || row.customer_id || row.advertiser_id || "",
    campaign_id: row.campaign_id || "",
    adset_id: row.adset_id || row.adgroup_id || "",
  };
}

export function matchesReportScope(row, scope, level = "campaign") {
  if (!scope || typeof scope !== "object") return true;
  const normalized = value => ({ ...reportEntityFields(value), campaign_name: value.campaign_name,
    adset_name: value.adset_name, ad_id: value.ad_id || value.creative_no || "",
    ad_name: value.ad_name || value.creative_name || "", _media: canonicalMedia(value) });
  return reportRowIdentity(normalized(row), level) === reportRowIdentity(normalized(scope), level);
}

// Older keyword exports omit account_id. Bind it only when the source RAW
// identifies exactly one account for the same campaign/adset identity.
export function filterReportScope(rows, scope, references, level = "campaign") {
  if (!scope || typeof scope !== "object") return {rows, ambiguousCount:0};
  const account = String(reportEntityFields(scope).account_id);
  if (!account) return {rows:rows.filter(row => matchesReportScope(row, scope, level)), ambiguousCount:0};
  const withoutAccount = row => ({...row, account_id:"", customer_id:"", advertiser_id:""});
  const wanted = withoutAccount(scope);
  const accounts = new Set();
  for (const row of references) {
    if (matchesReportScope(withoutAccount(row), wanted, level))
      accounts.add(String(reportEntityFields(row).account_id));
  }
  let ambiguousCount=0;
  const filtered=rows.filter(row => {
    if (reportEntityFields(row).account_id) return matchesReportScope(row, scope, level);
    if (!matchesReportScope(withoutAccount(row), wanted, level)) return false;
    if (accounts.size !== 1 || !accounts.has(account)) {ambiguousCount++;return false;}
    return true;
  });
  return {rows:filtered, ambiguousCount};
}
